<template>
  <div>
    <sidenav
      :item-edit.sync="itemEdit"
      :is-add.sync="isAdd"
      :is-sidebar-active.sync="isSidebarActive"
      :companies-options="companiesOptions"
      @refetch-data="refetchData"
    />
    <b-row class="my-1">
      <b-col cols="6" class="d-flex align-items-center">
        <BreadcrumbMenu />
      </b-col>

     <!--  <b-col cols="6" class="pr-3 text-right filters-col">
        <button-filters
          @show-modal="$root.$emit('bv::show::modal', $event)"
          :filters-count="filtersCount"
          @clear-search-filters="clearSearchFilters"
        />
      </b-col> -->
    </b-row>

    <!-- <filter-modal @action="buildFilters()" @clear="clearSearchFilters()">
      <template v-slot:main-filters>
        <filters-component
          :event-definition-options="eventDefinitionOptions"
          :event-definition-options-filter.sync="eventDefinitionOptionsFilter"
        />
      </template>
    </filter-modal> -->

    <!-- Table Container Card -->
    <b-card class="mx-2" no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label class="text-capitalize">{{ $t("table.show") }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label class="text-capitalize">{{ $t("table.entries") }}</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                :placeholder="$t('table.search')"
              />
              <b-button
                type="button"
                variant="info"
                class="text-capitalize mx-1"
                v-b-tooltip.hover
                :title="$t('messages.import.title')"
                v-b-modal.import_file
                v-if="$can('bulk_import', 'Employees')"
              >
                <feather-icon icon="UploadCloudIcon" size="15" />
              </b-button>
            <b-button
                v-if="$can('create', 'Employees')"
                variant="primary"
                @click="openAdd()"
              >
                <span class="text-nowrap text-capitalize">{{
                  `${$t("actions.add")} ${$tc("employees.title", 2)}`
                }}</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refListTable"
        class="position-relative"
        :items="fetchList"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        :empty-text="$t('no_record_found')"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #head()="data">
          <span> {{ $tc(data.label, 1) }}</span>
        </template>

        <template #head(company.name="data" )>
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <!-- img -->
        <template #cell(image)="data">
          <div class="d-flex justify-content-center align-items-center">
            <img
              v-if="data.item.image"
              :src="data.item.image.url"
              class="img-fluid rounded"
              style="max-width: 50px; max-height: 50px;"
              :alt="data.item.image.name"
            />
          </div>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-button
            :id="`actions-${data.item.id}`"
            tabindex="0"
            variant="white"
            class="px-1 btn-y"
          >
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </b-button>
          <b-popover
            :target="`actions-${data.item.id}`"
            triggers="focus"
            placement="bottom"
            custom-class="popover-p-0"
            variant="white"
          >
            <b-list-group class="m-0">
              <b-list-group-item
                v-if="$can('update', 'Employees')"
                class="border-0"
                button
                @click="openEdit(data.item)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50 text-capitalize">
                  {{ $t("actions.edit") }}
                </span>
              </b-list-group-item>

              <b-list-group-item
                v-if="$can('delete', 'Employees')"
                class="border-0"
                button
                @click="confirmDelete(data.item.id)"
              >
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50 text-capitalize">
                  {{ $t("actions.delete") }}
                </span>
              </b-list-group-item>
            </b-list-group>
          </b-popover>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted text-capitalize">{{
              $t("table.showing", {
                from: dataMeta.from,
                to: dataMeta.to,
                of: dataMeta.of,
              })
            }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <Pagination
              :totalList="totalList"
              :currentPage="currentPage"
              @updatePagination="update"
              :perPage="perPage"
            >
            </Pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal
      id="import_file"
      :title="`${$t('messages.import.title')}`"
      no-close-on-esc
      no-close-on-backdrop
      ref="modalImport"
    >
      <vue-dropzone
        id="dropzone_file"
        ref="dropzoneFile"
        :options="dropzoneOptions"
        class="dropzone-file"
        @vdropzone-file-added="addImportFile"
        @vdropzone-removed-file="removeImportFile"
      />
      <div v-if="importMessages.length > 0" class="mt-2 scroll">
        <span v-for="(message, index) in importMessages" :key="index">
          <p
            class="text-danger mb-0"
            v-for="(error, index) in message"
            :key="index"
          >
            {{ error }}
          </p>
        </span>
      </div>
      <template #modal-footer>
        <a :href="import_example_url" download>{{
          $t("messages.import.example_file")
        }}</a>
        <b-button
          variant="secondary"
          @click="$bvModal.hide('import_file')"
          :disabled="loadingImport"
        >
          {{ $t("actions.cancel") }}
        </b-button>
        <b-button
          variant="primary"
          @click="importExcel"
          :disabled="loadingImport"
        >
          {{ $t("actions.accept") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BButton,
  BDropdown,
  BDropdownItem,
  BPagination,
  BInputGroup,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ref } from "@vue/composition-api";
import useList from "./useList";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import Pagination from "@/components/Pagination.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Sidenav from "./Sidenav.vue";
//import FiltersComponent from "../components/FiltersComponent";
import ButtonFilters from "@/components/Filters/ButtonFilters.vue";
import FilterModal from "@/components/Filters/FilterModal.vue";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import vue2Dropzone from "vue2-dropzone";
import axios from "@axios";

export default {
  components: {
    Pagination,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    vSelect,
    ToastificationContent,
    Breadcrumb,
    Sidenav,
    //FiltersComponent,
    ButtonFilters,
    FilterModal,
    BreadcrumbMenu,
    vueDropzone: vue2Dropzone
  },

  setup(_, context) {
    //start pagination
    const update = (data) => {
      currentPage.value = data;
    };
    //end pagination

    const { t } = useI18nUtils();

    const toast = useToast();

    const isSidebarActive = ref(false);
    const itemEdit = ref({});
    const isAdd = ref(false);
    const dropzoneImportFile = ref(null);
    const dropzoneOptions = ref({
      url: "https://httpbin.org/post",
      paramName: "file",
      autoProcessQueue: false,
      addRemoveLinks: true,
      dictRemoveFile: t("actions.delete"),
      acceptedFiles: ".xlsx,.xls",
      maxFilesize: 10,
      dictDefaultMessage: t("messages.import.select_file") + " (.xlsx .xls)",
    });
    const loadingImport = ref(false);
    const importMessages = ref([]);
    const modalImport = ref(null);

    const openEdit = (item) => {
      isSidebarActive.value = true;
      itemEdit.value = JSON.parse(JSON.stringify(item));
      isAdd.value = false;
    };

    const trans = {
      "messages.delete.title": t("messages.delete.title"),
      "messages.delete.body": t("messages.delete.body"),
      "actions.delete": t("actions.delete"),
      "actions.cancel": t("actions.cancel"),
    };

    const {
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      formatDateAssigned,
      clearSearchFilters,
      buildFilters,
      filtersCount,
      companiesOptions
    } = useList();

    const confirmDelete = function (id) {
      const self = this;
      const storeInner = store;
      this.$swal({
        title: trans["messages.delete.title"],
        text: trans["messages.delete.body"],
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: trans["actions.delete"],
        cancelButtonText: trans["actions.cancel"],
        customClass: {
          confirmButton: "btn btn-primary text-capitalize",
          cancelButton: "btn btn-outline-danger ml-1 text-capitalize",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          storeInner
            .dispatch("employees/delete", id)
            .then((response) => {
              if (response.success) {
                toast({
                  component: ToastificationContent,
                  props: {
                    title: response.message,
                    icon: "CheckIcon",
                    variant: "success",
                  },
                });
                self.refetchData();
              } else {
                toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: response.message,
                      icon: "AlertTriangleIcon",
                      variant: "danger",
                    },
                  },
                  {
                    timeout: 10000,
                  }
                );
              }
            })
            .catch((response) => {
              toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: response.response.data.message,
                    icon: "AlertTriangleIcon",
                    variant: "danger",
                  },
                },
                {
                  timeout: 10000,
                }
              );
            });
        }
      });
    };

    const openAdd = () => {
      isAdd.value = true;
      isSidebarActive.value = true;
    };

    const itemFilter = ref();

    const addItemFilter = (data) => {
      itemFilter.value = data;
    };
    const addItemFilterSearch = (data) => {
      data.forEach((element) => {
        if (nameNav.value === element.text) {
          searchQuery.value = element.searchQuery;
        }
      });
    };
    const nameNav = ref("breadcrumbs.iot.dmp.rules");

    const addImportFile = (file) => {
      importMessages.value = [];
      dropzoneImportFile.value = file;
    };

    const removeImportFile = () => {
      dropzoneImportFile.value = null;
    };

    const importExcel = async () => {
      if (dropzoneImportFile.value == null) return;

      const formData = new FormData();

      formData.append("file", dropzoneImportFile.value);

      loadingImport.value = true;

      await axios.post('v1/employees/import', formData)
        .then((response) => {
          const { data } = response;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: "CheckIcon",
              variant: "success",
            },
          });

          dropzoneImportFile.value = null;
          modalImport.value.hide();
          refetchData();
        })
        .catch((error) => {
          //toast.clear(toastImportRems.value);

          toast({
            component: ToastificationContent,
            props: {
              title: 'Error al iniciar la importación',
              icon: "AlertTriangleIcon",
              variant: "danger",
            }
          });
        })
        .finally(() => {
          loadingImport.value = false;
        });
    };

    return {
      nameNav,
      addItemFilter,
      itemFilter,
      addItemFilterSearch,
      dropzoneOptions,
      dropzoneOptions,
      addImportFile,
      removeImportFile,
      import_example_url: `${window.__env.VUE_APP_BASE_URL}/import_examples/import_employees.xlsx`,
      loadingImport,
      importExcel,
      importMessages,
      modalImport,

      isSidebarActive,
      isAdd,
      itemEdit,
      openEdit,
      openAdd,
      confirmDelete,
      update,
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      formatDateAssigned,

      clearSearchFilters,
      buildFilters,
      filtersCount,

      companiesOptions
    };
  },
};
</script>
